<ng-template #content>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="h2 bold" i18n="vinscanner|@@vin">Vin</span><span class="h2 bold"> : {{qrResultString}}</span>
        </div>
      </div>

    </div>

  </div>
  <div class="modal-footer d-flex">
    <div class="justify-content-center mx-auto">
      <p i18n="vinscanner|@@loading">Chargement ... </p>
    </div>
  </div>
</ng-template>



<div class="vin-scanner-container container">
  <div class="row justify-content-md-center">
    <div class="col-12 col-md-8">
      <div i18n="vinscanner|@@vinscanner" class="h3 font-weight-bold text-center dark">VIN Scanner</div>
    </div>
  </div>


  <div class="row justify-content-md-center">
    <div class="col-12 col-md-8">
      <zxing-scanner [torch]="torchEnabled" [(device)]="currentDevice" (scanSuccess)="onCodeResult($event)"
        [formats]="formatsEnabled" [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
        (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>

      <div class="row justify-content-md-center mr-auto ml-auto">
        <div class="col-11 d-inline-flex mt-3">

        </div>
      </div>

    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/vinscanner/vinscanner.component.html